
import param from '~/utils/url/param.js'
export default {
  name: 'social-telegram',
  props: {
    url: {
      type: String,
      async default() {
        return await window.location.href
      }
    },
    title: { type: String, default: '' }
  },
  methods: {
    open() {
      window.open(
        'https://telegram.me/share/' +
          param({ url: this.url, text: this.title }),
        '__blank'
      )
    }
  }
}
